import React, {Component} from "react";
import PropTypes from "prop-types";
import MUIDataTable from "mui-datatables";
import {withAuth0} from "@auth0/auth0-react";
import {Button, Grid, IconButton, Tooltip} from "@material-ui/core";
import {connect} from "react-redux";
import {searchTaskRuleNotifications} from "../../../../redux/TaskRule/taskRule.action";
import {search as searchMessageTemplates} from "../../../../redux/notificate/action";
import Delete from "../../../../components/common/Delete";
import EditIcon from "@material-ui/icons/Edit";
import TaskRuleNotificationModal from "./task-rule-notification"

class TaskRuleNotifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false
    };
    this.isFilterDialogOpen = false;
    this.tableRef = React.createRef();
    this.columnsDisplay = undefined;
  }

  static propTypes = {
    taskRuleUuid: PropTypes.string.isRequired,
  };

  componentDidMount() {
    this.refresh();
  }

  refresh = () => {
    const { searchTaskRuleNotifications, searchMessageTemplates } = this.props;
    searchTaskRuleNotifications(this.props.taskRuleUuid);
    searchMessageTemplates({page:0, size:100});
  };

  handleModalClosed = (saved) => {
    this.setState({
      showModal: false,
    });
    if(saved)
      this.refresh();
  };

  onChangeColumnDisplay = () => {
    const state = this.tableRef?.current?.state;
    this.columnsDisplay = state.columns.reduce(
      (obj, item) => Object.assign(obj, { [item.name]: item.display }),
      {}
    );
  };

  isDisplay = (name) => {
    if (!this.columnsDisplay || !this.columnsDisplay.hasOwnProperty(name))
      return undefined;
    else return this.columnsDisplay[name];
  };

  mapToMessageTemplateInfo = (uuid, messageTemplateUuid) => {
      if(this.props.notificationTemplates?.content){
        let template = this.props.notificationTemplates.content.find ( x => x.uuid === messageTemplateUuid);
        return {
            uuid: uuid,
            messageTemplateUuid: messageTemplateUuid,
            subject: template.subject,
            content: template.content
        }
      }
      else
        return {
            uuid: uuid,
            messageTemplateUuid: messageTemplateUuid,
            subject:"loading"
        };
  }

  render() {
    const { taskRuleNotifications } = this.props;
    if (!taskRuleNotifications) return <React.Fragment>Loading...</React.Fragment>;

    const list = taskRuleNotifications.map ( item =>
        this.mapToMessageTemplateInfo(item.uuid, item.messageTemplateUuid)
    );
    const totalElements = taskRuleNotifications?.length ?? 0;

    const columns = [
      {
        name: "uuid",
        label: "UUID",
        options: {
          filter: true,
          sort: false,
          display: this.isDisplay("uuid") ?? false,
          customFilterListOptions: { render: (v) => `UUID: ${v}` },
          filterType: "textField",
        },
      },

      {
        name: "messageTemplateUuid",
        label: "MT UUID",
        options: {
          filter: true,
          sort: false,
          display: this.isDisplay("messageTemplateUuid") ?? false,
          customFilterListOptions: { render: (v) => `UUID: ${v}` },
          filterType: "textField",
        },
      },

      {
        name: "subject",
        label: "Subject",
        options: {
          filter: true,
          sort: true,
          display: this.isDisplay("subject") ?? true,
        },
      },

      {
        name: "content",
        label: "Content",
        options: {
          filter: true,
          sort: true,
          display: this.isDisplay("content") ?? true,
        },
      },
      {
        name: "Operations",
        options: {
          filter: false,
          sort: false,
          empty: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <div>
                <Tooltip title="Edit">
                  <IconButton
                    aria-label="Edit"
                    onClick={() => {
                      this.setState({
                        showModal: true,
                        data: {
                          uuid: tableMeta.rowData[0],
                          messageTemplateUuid: tableMeta.rowData[1]
                        }
                      });
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                </Tooltip>
                <Delete
                  url={`/taskRuleNotification/${tableMeta.rowData[0]}`}
                  callback={() => this.refresh()}
                />
              </div>
            );
          },
        },
      },
    ];

    const options = {
      filter: false,
      confirmFilters: false,
      serverSide: true,
      filterType: "dropdown",
      responsive: "vertical",
      pagination: false,
      download: false,
      print: false,
      search: false,
      count: totalElements,
      onTableChange: (action, tableState) => {
        switch (action) {
          case "viewColumnsChange":
            this.onChangeColumnDisplay();
            break;
          case "onFilterDialogOpen":
            this.isFilterDialogOpen = true;
            break;
          case "filterChange":
            if (this.isFilterDialogOpen) return;
            else this.refresh();
            break;
          case "onFilterDialogClose":
            this.isFilterDialogOpen = false;
          case "sort":
          default:
            //console.log("Not handled action " + action);
        }
      },
      customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
        return (
          <div style={{ marginTop: "40px" }}>
            <Button
              variant="contained"
              style={{ color: "white", backgroundColor: "#36b9cc" }}
              onClick={() => {
                applyNewFilters();
              }}
            >
              Apply
            </Button>
          </div>
        );
      },
    };

    return (
      <React.Fragment>
        <Grid container spacing={2}>
          <Grid item sm={12} xs={12} md={12} lg={12}>
            <Button
              variant="contained"
              color="primary"
              style={{ float: "right" }}
              onClick={() => {
                this.setState({
                  showModal: true,
                  data: {
                  }
                });
              }}
            >Add</Button>
          </Grid>
        </Grid>
        <MUIDataTable
          data={list}
          columns={columns}
          options={options}
          ref={this.tableRef}
        />

        <TaskRuleNotificationModal
          open={this.state.showModal}
          callback={this.handleModalClosed}
          taskRuleUuid={this.props.taskRuleUuid}
          data={this.state.data}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  taskRuleNotifications: state.taskRuleReducer.taskRuleNotifications,
  notificationTemplates: state.notificationReducer.notificationTemplates
});

const mapDispatchToProps = (dispatch) => ({
  searchTaskRuleNotifications: (params) => dispatch(searchTaskRuleNotifications(params)),
  searchMessageTemplates: (params) => dispatch(searchMessageTemplates(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withAuth0(TaskRuleNotifications));
